import React from 'react';
import { BottomTabBar, BottomTabBarProps } from '@react-navigation/bottom-tabs';
import { useGetActiveTabRouteIndex } from '@/hooks/use-get-active-tab-route-index';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useSalesRepMode } from '@/hooks/use-sales-rep-mode';
import { useTheme } from '@react-navigation/native';
import { View } from 'react-native';

export const TabBar: React.FC<BottomTabBarProps> = (props) => {
  const { bottom } = useSafeAreaInsets();
  const salesRepMode = useSalesRepMode();
  const theme = useTheme();
  const activeTabRouteIndex = useGetActiveTabRouteIndex();

  // Tab bar should only be visible on the first route of the tab routes
  return activeTabRouteIndex === 0 ? (
    <View
      style={[
        { paddingBottom: bottom },
        salesRepMode ? { backgroundColor: theme.colors.primary } : null,
      ]}
    >
      <BottomTabBar {...props} />
    </View>
  ) : null;
};
